module.exports = __webpack_public_path__ + "img/reoptimize.8e59792c.svg";